// core version + navigation, pagination modules:
// import Swiper, {Autoplay, Navigation, Pagination} from 'swiper'
import Swiper from 'swiper';
import { A11y, Autoplay, Manipulation, Navigation, Pagination } from 'swiper/modules';

export default class Sliders {
  constructor(slider, index) {
    this.slider = slider
    this.index = index
    this.slides = Array.from(this.slider.querySelectorAll('.swiper-slide'))
    this.arrows = this.slider.querySelector('.swiper-arrows')

    this.options = this.setOptions()
    this.initSlider()
  }

  setOptions() {
    let options = {}

    if (this.slider.classList.contains('swiper--regular')) {
      options = {
        modules: [A11y, Autoplay, Manipulation, Navigation, Pagination],
        centeredSlides: true,
        keyboardControl: false,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next--regular',
          prevEl: '.swiper-button-prev--regular',
        },
        pagination: {
          el: '.swiper-pagination--regular',
          clickable: true,
          type: 'bullets',
          renderBullet: function (index, className) {
            return `<button class="${className}" role="tab" aria-selected="${index === 0 ? 'true' : 'false'}" aria-label="Vai alla slide ${index + 1}"></button>`;
          }
        },
        slidesPerView: 'auto',
        spaceBetween: 28,
        watchOverflow: true,
        breakpoints: {
          768: {
            centeredSlides: false,
            grabCursor: true,
            loop: false,
            spaceBetween: 40,
          },
        },
        a11y: {
          enabled: true,
          containerRole: 'region',
          containerRoleDescriptionMessage: 'carousel',
          containerMessage: 'Carosello informazioni',
          slideRole: 'tabpanel',
          prevSlideMessage: 'Slide precedente',
          nextSlideMessage: 'Slide successiva',
          paginationBulletMessage: 'Vai alla slide {{index}}',
          itemRoleDescriptionMessage: 'slide',
        },
      }
    } else if (this.slider.classList.contains('swiper--3-blocks')) {
      options = {
        modules: [A11y, Pagination],
        centeredSlides: true,
        keyboardControl: false,
        loop: false,
        pagination: {
          el: '.swiper-pagination--3-blocks',
          clickable: true,
          type: 'bullets',
          renderBullet: function (index, className) {
            return `<button class="${className}" role="tab" aria-selected="${index === 0 ? 'true' : 'false'}" aria-label="Vai alla slide ${index + 1}"></button>`;
          }
        },
        slidesPerView: 'auto',
        spaceBetween: 16,
        watchOverflow: true,
        breakpoints: {
          1024: {
            centeredSlides: false,
          },
        },
        a11y: {
          enabled: true,
          containerRole: 'region',
          containerRoleDescriptionMessage: 'carousel',
          containerMessage: 'Carosello con 3 blocchi informazioni',
          slideRole: 'tabpanel',
          paginationBulletMessage: 'Vai alla slide {{index}}',
          itemRoleDescriptionMessage: 'slide',
        },
      }
    } else if (this.slider.classList.contains('swiper--partners')) {
      options = {
        modules: [A11y, Navigation, Pagination],
        centeredSlides: false,
        keyboardControl: true,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next--partners',
          prevEl: '.swiper-button-prev--partners',
        },
        slidesPerView: 'auto',
        spaceBetween: 10,
        watchOverflow: true,
        breakpoints: {
          768: {
            spaceBetween: 25,
          },
          1024: {
            spaceBetween: 50,
          },
        },
        a11y: {
          enabled: true,
          containerRole: 'region',
          containerRoleDescriptionMessage: 'carousel',
          containerMessage: 'Carosello partner',
          prevSlideMessage: 'Slide precedente',
          nextSlideMessage: 'Slide successiva',
          paginationBulletMessage: 'Vai alla slide {{index}}',
          itemRoleDescriptionMessage: 'slide',
        },
      }
    } else if (this.slider.classList.contains('swiper--video')) {
      options = {
        modules: [A11y, Navigation],
        centeredSlides: true,
        keyboardControl: false,
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: 22,
        watchOverflow: true,
        navigation: {
          nextEl: '.swiper-button-next--video',
          prevEl: '.swiper-button-prev--video',
        },
        breakpoints: {
          768: {
            centeredSlides: false,
          }
        },
        a11y: {
          enabled: true,
          containerRole: 'region',
          containerRoleDescriptionMessage: 'carousel',
          containerMessage: 'Carosello video',
          prevSlideMessage: 'Slide precedente',
          nextSlideMessage: 'Slide successiva',
          itemRoleDescriptionMessage: 'slide',
        },
      }      
    } else if (this.slider.classList.contains('swiper--solutions')) {
      options = {
        modules: [A11y, Navigation, Pagination],
        centeredSlides: false,
        keyboardControl: true,
        loop: false,
        // navigation: {
        //   nextEl: '.swiper-button-next--solutions',
        //   prevEl: '.swiper-button-prev--solutions',
        // },
        hashNavigation: {
          watchState: true,
        },
        pagination: {
          el: '.swiper-pagination--solutions',
          clickable: true,
          type: 'bullets',
          renderBullet: function (index, className) {
            return `<button class="${className}" role="tab" aria-selected="${index === 0 ? 'true' : 'false'}" aria-label="Vai alla slide ${index + 1}"></button>`;
          }
        },
        slidesPerView: 'auto',
        watchOverflow: true,
        // breakpoints: {
        //   768: {
        //     navigation: {
        //       nextEl: '.swiper-button-next--solutions',
        //       prevEl: '.swiper-button-prev--solutions',
        //     },
        //     slidesPerView: 3,
        //   },
        // },
        a11y: {
          enabled: true,
          containerRole: 'region',
          containerRoleDescriptionMessage: 'carousel',
          containerMessage: 'Carosello soluzioni',
          slideRole: 'tabpanel',
          prevSlideMessage: 'Slide precedente',
          nextSlideMessage: 'Slide successiva',
          paginationBulletMessage: 'Vai alla slide {{index}}',
          itemRoleDescriptionMessage: 'slide',
        },
      }
    } else if (this.slider.classList.contains('swiper--news')) {
      options = {
        modules: [A11y, Navigation, Pagination],
        centeredSlides: true,
        keyboardControl: false,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next--news',
          prevEl: '.swiper-button-prev--news',
        },
        pagination: {
          el: '.swiper-pagination--news',
          clickable: true,
          type: 'bullets',
          renderBullet: function (index, className) {
            return `<button class="${className}" role="tab" aria-selected="${index === 0 ? 'true' : 'false'}" aria-label="Vai alla slide ${index + 1}"></button>`;
          }
        },
        slidesPerView: 'auto',
        spaceBetween: 28,
        watchOverflow: true,
        breakpoints: {
          768: {
            centeredSlides: false,
            grabCursor: true,
            loop: false,
            spaceBetween: 30,
          },
        },
        a11y: {
          enabled: true,
          enabled: true,
          containerRole: 'region',
          containerRoleDescriptionMessage: 'carousel',
          containerMessage: 'Carosello news',
          slideRole: 'tabpanel',
          prevSlideMessage: 'Slide precedente',
          nextSlideMessage: 'Slide successiva',
          paginationBulletMessage: 'Vai alla slide {{index}}',
          itemRoleDescriptionMessage: 'slide',
        },
      }
    } else if (this.slider.classList.contains('swiper--related')) {
      options = {
        modules: [A11y, Pagination],
        centeredSlides: true,
        keyboardControl: false,
        loop: false,
        hashNavigation: {
          watchState: true,
        },
        pagination: {
          el: '.swiper-pagination--related',
          clickable: true,
          type: 'bullets',
          renderBullet: function (index, className) {
            return `<button class="${className}" role="tab" aria-selected="${index === 0 ? 'true' : 'false'}" aria-label="Vai alla slide ${index + 1}"></button>`;
          }
        },
        slidesPerView: 1,
        spaceBetween: 20,
        watchOverflow: true,
        breakpoints: {
          768: {
            centeredSlides: false,
            slidesPerView: 4,
            spaceBetween: 40,
          },
        },
        a11y: {
          enabled: true,
          containerRole: 'region',
          containerRoleDescriptionMessage: 'carousel',
          containerMessage: 'Carosello news correlate',
          slideRole: 'tabpanel',
          prevSlideMessage: 'Slide precedente',
          nextSlideMessage: 'Slide successiva',
          paginationBulletMessage: 'Vai alla slide {{index}}',
          itemRoleDescriptionMessage: 'slide',
        },
      }
    } else if (this.slider.classList.contains('swiper--vertical')) {
      options = {
        modules: [A11y, Navigation],
        centeredSlides: false,
        direction: 'vertical',
        keyboardControl: false,
        loop: false,
        navigation: {
          nextEl: '.swiper-button-next--vertical',
          prevEl: '.swiper-button-prev--vertical',
        },
        slidesPerView: 1,
        watchOverflow: true,
        a11y: {
          enabled: true,
          containerRole: 'region',
          containerRoleDescriptionMessage: 'carousel',
          containerMessage: 'Carosello verticale informazioni',
          prevSlideMessage: 'Slide precedente',
          nextSlideMessage: 'Slide successiva',
          itemRoleDescriptionMessage: 'slide',
        },
      }
    }

    return options
  }


  initSlider() {
    console.debug('  -> Sliders init')
    let swiperInstance = new Swiper(this.slider, this.options)

    swiperInstance.init()
    this.swiperInstance = swiperInstance

    // this.loadedCheck()

    // window.addEventListener('resize', () => {
    //   let viewportHeight = window.innerHeight
    //   let viewportWidth = window.innerWidth

    //   if (
    //     this.slider.classList.contains('swiper--solutions') ||
    //     this.slider.classList.contains('swiper--related')
    //   ) {
    //     if (viewportWidth <= 768 && !swiperInstance) {
    //       swiperInstance = new Swiper(this.slider, this.options)
    //     } else if (viewportWidth > 768 && swiperInstance) {
    //       this.destroy()
    //       swiperInstance = undefined
    //     }
    //     this.swiperInstance = swiperInstance
    //   }
    // })

    if( this.slider.classList.contains('swiper--partners') ){
      let partnerFilterButton = document.querySelectorAll('.section--partners .filter')

      partnerFilterButton.forEach((button) => {
        let swiperPartner = document.querySelector('.swiper--partners').swiper
        button.addEventListener('click', function(e) {
          swiperPartner.slideTo(0);
        })
      })
    }

    if( this.slider.classList.contains('swiper--title-slide') ){
      const swiperEl = this.slider;
      const swiperWrapper = swiperEl.querySelector('.swiper-wrapper')
      const firstSlide = swiperEl.querySelector('.swiper-slide--title')
    
      let firstSlideBackup = firstSlide
    
      function handleSlideVisibility(mq) {
        if( mq.matches ){
          if( firstSlide && firstSlide.parentElement === swiperWrapper ){
            firstSlideBackup = firstSlide
            firstSlide.remove()
          }
        } else{
          if( firstSlideBackup && !swiperWrapper.contains(firstSlideBackup) ){
            swiperWrapper.prepend(firstSlideBackup)
          }
        }
      }

      const mediaQuery = window.matchMedia('(max-width: 767px)')
      handleSlideVisibility(mediaQuery)
      mediaQuery.addEventListener('change', handleSlideVisibility)
    }

    if( swiperInstance.pagination && swiperInstance.pagination.el ){
      const mediaQuery = window.matchMedia('(max-width: 767px)')
      this.setupKeyboardNavigation(swiperInstance)
      mediaQuery.addEventListener('change', () => {
        // Forcing swiper pagination update
        swiperInstance.update()
        
        // setTimeout(() => {
        this.setupKeyboardNavigation(swiperInstance)
        // }, 100)
      })
    }
    
  }

  setupKeyboardNavigation( swiperInstance ) {
    const swiperId = swiperInstance.el.querySelector('.swiper-wrapper')?.id.replace('swiper-wrapper-', '') || `swiper-${Math.random().toString(36).slice(2, 11)}`
    const slides = swiperInstance.slides;
    const bulletContainer = swiperInstance.pagination.el
    const bullets = bulletContainer.querySelectorAll('.swiper-pagination-bullet')
    
    if( !bullets.length ) return

    slides.forEach((slide, index) => {
      slide.setAttribute('aria-labelledby', bullets[index]?.id || '')
    })
    
    bulletContainer.setAttribute('role', 'tablist')

    bullets.forEach((bullet, index) => {
      const bulletId = `${swiperId}-bullet-${index}`
      bullet.setAttribute('id', bulletId)
      this.updateBulletsState(bullets, swiperInstance.realIndex)

      bullet.addEventListener('keydown', (e) => {
        let newIndex = -1;

        if( e.key === 'ArrowRight' ){
          newIndex = (index + 1) % bullets.length;
        } else if( e.key === 'ArrowLeft' ){
          newIndex = (index - 1 + bullets.length) % bullets.length;
        }

        if( newIndex !== -1 ){
          e.preventDefault();
          bullets[newIndex].focus()
          bullets[newIndex].click()
        }
      })

      bullet.addEventListener('click', () => this.updateBulletsState(bullets, index))
    })

    swiperInstance.on('slideChange', () => {
      this.updateBulletsState(bullets, swiperInstance.realIndex)
    })
  }

  updateBulletsState(bullets, activeIndex) {
    bullets.forEach((bullet, index) => {
        const isActive = index === activeIndex
        bullet.setAttribute('aria-selected', isActive ? 'true' : 'false')
        bullet.setAttribute('tabindex', isActive ? '0' : '-1')
    })
  }

  // loadedCheck() {
  //   let viewportHeight = window.innerHeight
  //   let viewportWidth = window.innerWidth

  //   if (
  //     this.slider.classList.contains('swiper--solutions') ||
  //     this.slider.classList.contains('swiper--related')
  //   ) {
  //     if (viewportWidth > 768) {
  //       this.destroy()
  //     }
  //   }
  // }

  destroy() {
    console.debug('  -> Sliders destroy')
    this.swiperInstance.destroy()
  }

  static destroyAll() {
    console.debug('  -> Sliders destroy all')
    Sliders.items.forEach((slider) => {
      slider.destroy()
    })
  }

  static init() {
    console.debug('== Sliders components ==')
    Sliders.items = Array.from(document.querySelectorAll('.swiper')).map(
      (slider, index) => new Sliders(slider, index)
    )
  }
}
